module.exports = __webpack_public_path__ + "img/gufen.120022c6.png";